import { Config } from "../interfaces/Config";

export const getClassroomUrl = (
    i18n: Config["i18n"],
    classroomId: string
): string => {
    return `/${i18n.dashboard?.paths.dashboard}/${i18n.dashboard?.paths.classes}/${classroomId}`;
};
